import { PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { useGetMeals } from "./useGetMeals"
import { MealEntity } from "../../Objects/MealsAndDrinks/MealEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useSaveMeals = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const { handleGetMeals } = useGetMeals()

  const handleSavesMeals = async (mealsChange: MealEntity, onSuccess: any, imageFile?: any | null) => {
    try {
      enableLoad()

      var response = null

      if (mealsChange.id !== -1) {
        response = await PutFormRequest(`${API_ROUTES.MEAL.PUT}/${mealsChange.id}`, mealsChange.toJSON(imageFile))
      } else {
        response = await PostFormRequest(API_ROUTES.MEAL.CREATE, mealsChange.toJSON(imageFile))
      }

      if (response.success) {
        await handleGetMeals(onSuccess)

        return
      }

      throw new Error(response.message)
    } catch (e: any) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleSavesMeals,
  }
}
